import PrescribedDaysConfigForm from './PrescribedDaysConfigForm';

export default PrescribedDaysConfigForm;
